export default "__VITE_ASSET__CvE19BpE__"